import axios from 'axios';
import type {
  IGetSupraUsersByLocationQuery,
  IGetSupraUsersByLocationRequest,
  IGetSupraUsersByLocationResponse,
} from '@/app-package';

const getSupraUsersByLocation = async (
  params: IGetSupraUsersByLocationQuery,
) => {
  const config: IGetSupraUsersByLocationRequest = {
    url: '/user/supra',
    method: 'get',
    params,
  };

  const { data } =
    await axios.request<IGetSupraUsersByLocationResponse>(config);

  return data;
};

export default getSupraUsersByLocation;
